module.exports = __webpack_public_path__ + "static/media/outlet2.54e40260.png";